import { render } from "./MainLogo.vue?vue&type=template&id=6952d3b2&scoped=true"
import script from "./MainLogo.vue?vue&type=script&lang=js"
export * from "./MainLogo.vue?vue&type=script&lang=js"

import "./MainLogo.vue?vue&type=style&index=0&id=6952d3b2&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6952d3b2"]])

export default __exports__